import {useTranslation} from "react-i18next";
import FormFieldBox from "../../common/form/FormFieldBox";
import FormRow from "../../common/form/FormRow";
import React, {useEffect} from "react";
import {Control} from "react-hook-form";
import FormCheckbox from "../../common/form/FormCheckbox";
import {UseFormGetFieldState, UseFormSetValue} from "react-hook-form/dist/types/form";

type Props = {
    index: number
    control: Control<any>
    setValue: UseFormSetValue<any>
    getFieldState: UseFormGetFieldState<any>
}


export const AutoFillBlfForm = ({ index, control, setValue, getFieldState }: Props) => {
    const { t } = useTranslation()

    useEffect(() => {
        setValue(`fieldUpdates.${index}.values.0.selected`, true)
    }, [setValue, index]);

    return (<FormRow>
        <FormFieldBox>
            <FormCheckbox
                label={t('cpes.config.MPP_AUTOFILL_BLF')}
                name={`fieldUpdates.${index}.values.0.selected`}
                control={control}
                setValue={setValue}
                getFieldState={getFieldState}
            />
        </FormFieldBox>
    </FormRow>)
}
